import { createFileRoute } from '@tanstack/react-router';

import { ensureProjectMediaQueryData } from '@/api/media';
import { MediaDatabase } from '@/features/project-media/components/media-database';

export const Route = createFileRoute(
  '/_authenticated/_sidebar-layout/projects/$projectId/_dashboard-layout/media/'
)({
  loader: ensureProjectMediaQueryData,
  component: MediaDatabase,
});
